import { declareVueComponent } from '/vodalys/vvuejs/vueRegister.mjs'
import { Container, Draggable } from './vue-smooth-dnd/src/main.js'

declareVueComponent('Container', Container)
declareVueComponent('Draggable', Draggable)

export * from './vue-smooth-dnd/src/main.js'